// S2-FE2: Wordmark
// Inline styles only — no external CSS file.

export interface WordmarkProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  theme?: 'dark' | 'light';
}

const sizeMap: Record<string, number> = {
  sm: 14,
  md: 18,
  lg: 24,
  xl: 36,
};

export function Wordmark({ size = 'md', theme = 'dark' }: WordmarkProps) {
  const fontSize = sizeMap[size];

  // Colors reference CSS custom properties via var() in inline styles
  const airColor = theme === 'dark' ? 'var(--text-primary)' : 'var(--neutral-950)';
  const gentColor = theme === 'dark' ? 'var(--signal-400)' : 'var(--signal-600)';

  return (
    <span
      style={{
        fontFamily: "var(--font-primary)",
        fontWeight: 700,
        fontSize: `${fontSize}px`,
        letterSpacing: '0.06em',
        lineHeight: 1,
      }}
      aria-label="Airgent"
    >
      <span style={{ color: airColor }}>Air</span>
      <span style={{ color: gentColor }}>gent</span>
    </span>
  );
}
